import { Component, Input, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../shared/theme.service';
import { ModalService } from '../lxp/modal.service';
import { VbLxpRaceControlMarqueeComponent } from './vb-lxp-race-control-marquee.component';
import { Router } from '@angular/router';

@Component({
	selector: 'vb-lxp-footer',
	standalone: true,
	imports: [CommonModule, VbLxpRaceControlMarqueeComponent],
	templateUrl: './vb-lxp-footer.component.html',
	styleUrls: ['./vb-lxp-footer.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class VbLxpFooterComponent {
	@Input() imagePaths: { src: string; link: string }[] = [];

	public themeService = inject(ThemeService);
	public modalService = inject(ModalService);
	private readonly router = inject(Router);

	public showMarquee = true;

	public get isAdminPage(): boolean {
		const url = this.router.url;
		return url === '/admin' || url.startsWith('/admin/');
	}
}
